import React, { useState } from "react";
import { setOrganisationDomain } from "../../api/branding";

function BrandingGateOverlay({ onSuccess, rootDomainSuffix = ".xecurify.com" }) {
  const [orgName, setOrgName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    setError("");
    let name = (orgName || "").trim();
    if (!name) {
      setError("Please enter an organization name, e.g., your-company");
      return;
    }
    // Organization name only (send as-is from input)
    const organizationName = name;
    setLoading(true);
    try {
      const { error: apiError } = await setOrganisationDomain({
        organisation_name: organizationName,
      });
      if (apiError) {
        setError(
          (apiError?.message && Array.isArray(apiError.message) ? apiError.message.join(", ") : apiError?.message) ||
            "Failed to save branding. Please try again."
        );
        setLoading(false);
        return;
      }
      setLoading(false);
      if (typeof onSuccess === "function") onSuccess();
    } catch (e) {
      setLoading(false);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.35)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
            width: "min(560px, 92vw)",
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 10px 24px rgba(0,0,0,0.18)",
            padding: 24,
        }}
      >
        <h3 style={{ margin: 0, marginBottom: 16 }}>Set Organisation Branding</h3>
        <p style={{ marginTop: 0, color: "#555" }}>
          Enter your organization name to continue. Your domain will be created under {rootDomainSuffix}.
        </p>

        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <div style={{ flex: 1 }}>
            <label htmlFor="orgName" style={{ display: "block", fontSize: 12, color: "#444", marginBottom: 6 }}>
              Organization Name
            </label>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                id="orgName"
                type="text"
                placeholder="your-company"
                value={orgName}
                onChange={(e) => setOrgName(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: 8,
                  border: "1px solid #dadce0",
                  outline: "none",
                }}
              />
              <div style={{ whiteSpace: "nowrap", color: "#333" }}>{rootDomainSuffix}</div>
            </div>
          </div>
        </div>

        {error ? <div style={{ color: "#b00020", marginTop: 12 }}>{error}</div> : null}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 18 }}>
          <button
            onClick={handleSave}
            disabled={loading}
            style={{
              padding: "10px 16px",
              backgroundColor: "#0d6efd",
              color: "white",
              border: "none",
              borderRadius: 8,
              cursor: loading ? "not-allowed" : "pointer",
              minWidth: 120,
            }}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BrandingGateOverlay;


